// Both borrow the adjudicate permission until they get their own.
export const ADJUST_LINE_PERMISSION = 'clm_AdjudicateClaimItem' as const;
export const MANAGE_HOLDS_PERMISSION = 'clm_AdjudicateClaimItem' as const;
// Same permission that edits the job's charges (Claim Editors and up).
export const ATTACH_HOLD_EVIDENCE_PERMISSION = 'clm_ManageClaimItemCure' as const;
